'use client';

import React from 'react';
import { useRouter } from 'next/navigation';

const ErrorPage = () => {
    const router = useRouter();

    const handleRefresh = () => {
        // Refresh the current page when the user clicks refresh
        router.refresh();
    };

    return (
        <div className='flex flex-col justify-center items-center min-h-screen bg-gray-100 p-4'>
            <h1 className='text-4xl font-bold text-red-600 mb-4'>خطا رخ داده است</h1>
            <p className='text-lg text-gray-700 mb-6'>
                متاسفانه مشکلی در بارگذاری صفحه ایجاد شده است. لطفاً مجدداً تلاش کنید.
            </p>
            <button
                onClick={handleRefresh}
                className='px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:outline-none mb-4'
            >
                تلاش مجدد
            </button>
        </div>
    );
};

export default ErrorPage;
